export default __webpack_public_path__ + "static/media/lightsaber.eb7d4cd6.svg";